module.exports = __webpack_public_path__ + "img/partnerMobile.7b722bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/partnerMobile.png
// module id = IPO2
// module chunks = 0